export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href =
    'https://learn.microsoft.com/en-us/archive/technet-wiki/35748.office-365-what-is-customer-lockbox-and-how-to-enable-it';
